import { useRef, useCallback } from 'react';

/**
 * Prevents double-click / rapid re-submissions.
 * Returns a `guard(asyncFn)` that silently skips if the previous call is still in-flight.
 *
 * Usage:
 *   const guard = useSubmitGuard();
 *   const handleSave = async (e) => {
 *     e.preventDefault();
 *     guard(async () => { await axios.post(...); });
 *   };
 */
export default function useSubmitGuard() {
  const busyRef = useRef(false);

  const guard = useCallback(async (asyncFn) => {
    if (busyRef.current) return;
    busyRef.current = true;
    try {
      await asyncFn();
    } finally {
      busyRef.current = false;
    }
  }, []);

  return guard;
}
